'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var gsap_1 = require("gsap");
var ScrollTrigger_1 = require("gsap/ScrollTrigger");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
var Scroll;
(function (Scroll) {
    // myScroll
    var myScroll = /** @class */ (function () {
        function myScroll() {
            $(window).on('scroll', function (e) {
                var scroll = $(e.currentTarget).scrollTop();
                var aboutPosition = $('#about').offset().top;
                var galleryPosition = $('#gallery').offset().top;
                var archivePosition = $('#archive').offset().top;
                var name = '';
                var buffer = $(window).outerHeight() / 2;
                if (scroll > aboutPosition - buffer) {
                    name = 'about';
                }
                if (scroll > galleryPosition - buffer) {
                    name = 'gallery';
                }
                if (scroll > archivePosition - buffer) {
                    name = 'archive';
                }
                $('.bulletNaviCircle').attr('data-name', name);
            });
        }
        return myScroll;
    }());
    Scroll.myScroll = myScroll;
    var Common = /** @class */ (function () {
        function Common() {
            gsap_1.gsap.utils.toArray('.bulletFadeIn').forEach(function (element) {
                var start = 'top bottom';
                var check = $(element).attr('data-check');
                var customY = $(element).attr('data-y') || 80;
                var end_position = $(element).attr('data-end-position') || 'center bottom';
                gsap_1.gsap.set(element, {
                    y: customY,
                    opacity: 0.2,
                });
                var markers = false;
                if (check === 'true') {
                    markers = true;
                }
                gsap_1.gsap.to(element, {
                    y: 0,
                    opacity: 1,
                    scrollTrigger: {
                        trigger: element,
                        start: start,
                        end: end_position,
                        markers: markers,
                        scrub: 1
                    }
                });
            });
            ScrollTrigger_1.ScrollTrigger.matchMedia({
                "(min-width: 1200px)": function () {
                    gsap_1.gsap.utils.toArray('.bulletParallax').forEach(function (element) {
                        var parallaxParam = element.getAttribute('data-parallax') || -100;
                        gsap_1.gsap.to(element, {
                            y: parallaxParam,
                            scrollTrigger: {
                                trigger: element,
                                start: 'top bottom',
                                end: 'bottom top',
                                scrub: 0.5,
                                //markers: true
                            }
                        });
                    });
                },
                "(max-width: 1199px)": function () {
                    gsap_1.gsap.utils.toArray('.bulletParallax').forEach(function (element) {
                        var parallaxParam = Number(element.getAttribute('data-parallax')) || -100;
                        if (parallaxParam === -100) {
                            parallaxParam = -125;
                        }
                        gsap_1.gsap.to(element, {
                            y: parallaxParam + 100,
                            scrollTrigger: {
                                trigger: element,
                                start: 'top bottom',
                                end: 'bottom top',
                                scrub: 0.5,
                                //markers: true
                            }
                        });
                    });
                }
            });
            ScrollTrigger_1.ScrollTrigger.matchMedia({
                "(max-width: 1199px)": function () {
                }
            });
        }
        return Common;
    }());
    Scroll.Common = Common;
    // Movie
    var Movie = /** @class */ (function () {
        function Movie() {
            var movie = gsap_1.gsap.timeline({
                scrollTrigger: {
                    trigger: '.paramBlurTarget',
                    start: 'center center',
                    // markers: true,
                    end: "+=100%",
                    scrub: 1,
                }
            });
            movie.fromTo('.bulletMovie', { "filter": "blur(0px)", "opacity": 1 }, { "filter": "blur(15px)", "opacity": 0.4, ease: "Power4.out" });
        }
        return Movie;
    }());
    Scroll.Movie = Movie;
})(Scroll || (Scroll = {}));
exports.default = Scroll;
